import { api } from './api';
import type { EvidenceLabel, EvidenceLabelBundle } from '@sr-test-wizard/shared';

export interface CreateEvidenceLabelInput {
  key: string;
  name?: string;
  definition?: string;
  evidenceType?: string;
  isVisual?: boolean;
}

export interface UpdateEvidenceLabelInput {
  key?: string;
  name?: string;
  definition?: string;
  evidenceType?: string;
  isVisual?: boolean;
}

/**
 * Typed wrappers around `/api/evidence-labels`. Mirrors
 * `testGuidanceApi` - same generic transport, same naming, same
 * shared-types contract.
 */
export const evidenceLabelsApi = {
  list: () => api.get<EvidenceLabelBundle>('/api/evidence-labels'),
  create: (input: CreateEvidenceLabelInput) =>
    api.post<EvidenceLabel>('/api/evidence-labels', input),
  update: (id: string, input: UpdateEvidenceLabelInput) =>
    api.put<EvidenceLabel>(`/api/evidence-labels/${encodeURIComponent(id)}`, input),
  remove: (id: string) =>
    api.delete<{ id: string; removed: boolean }>(
      `/api/evidence-labels/${encodeURIComponent(id)}`,
    ),
};
